<template>

  <div :class="`col-lg-6 quick-access col-xl-${options.colSize || 3}`">

    <list-groups :options="options">

        <span slot="action" class="label label-success">
          {{ pagination.total }}
        </span>

      <b-list-group-item
        slot="card"
        v-for="item in items"
        :key="item.id"
        :target="options.link.target || '_self'"
        class="flex-column align-items-start quick-access">

        <div class="w-100 justify-content-between">

          <h5 class="w-100 mb-0">
            {{ item.name }}
          </h5>

          <small class="w-100 item-hour" v-if="item.created_at" style="padding-top: 4px;">

            <b>

              <i class="fa fa-download" aria-hidden="true"></i> Total de Downloads: {{ item.downloads }}

            </b>

          </small>

        </div>

      </b-list-group-item>

    </list-groups>

  </div>

</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-files-registered',
  data () {
    return {
      items: [],
      pagination: {},
      options: {
        name: 'Últimos Downloads',
        caption: '',
        colSize: 3,
        entity: {
          url: '/system/files',
          params: {
            per_page: 5,
            _order: 'downloads:desc'
          }
        },
        link: false
      }
    }
  },
  methods: {
    refresh () {
      let self = this
      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>

  .item-hour {
    color: #ccc;
    font-size: 12px !important;
  }

  .list-group-item {
    cursor: pointer;

    &:hover {

      h5 {
        color: #01a1db !important;
      }

    }

  }

  .card-body {

    h5 {
      line-height: 24px;
      color: #3e515b;
    }
  }
  .card-header {
    .card-actions {
      .label {
       border-radius: 0px;
       padding: 15px 0px;
       display: inline-block;
       background: #e36940; /* Old browsers */
       background: -moz-linear-gradient(45deg, #e36940 0%, #fe4c88 100%); /* FF3.6-15 */
       background: -webkit-linear-gradient(45deg, #e36940 0%,#fe4c88 100%); /* Chrome10-25,Safari5.1-6 */
       background: linear-gradient(45deg, #e36940 0%,#fe4c88 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
       filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36940', endColorstr='#fe4c88',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/System/FilesRegistered.vue